import { Link, Navigate, Route, Routes } from "react-router-dom";
import { Compass } from "lucide-react";

import { usarSesion } from "./sesion/ContextoSesion.tsx";
import { Marco } from "./componentes/Marco.tsx";
import { Marca } from "./componentes/Marca.tsx";
import { Boton, Tarjeta, Vacio } from "./componentes/ui.tsx";

import { Integracion } from "./paginas/Integracion.tsx";
import { AceptarInvitacion } from "./paginas/AceptarInvitacion.tsx";
import { Alertas } from "./paginas/Alertas.tsx";
import { Bandeja } from "./paginas/Bandeja.tsx";
import { Caja } from "./paginas/Caja.tsx";
import { Cartera } from "./paginas/Cartera.tsx";
import { Configuracion } from "./paginas/Configuracion.tsx";
import { Cuenta } from "./paginas/Cuenta.tsx";
import { Empezar } from "./paginas/Empezar.tsx";
import { Entrar } from "./paginas/Entrar.tsx";
import { Equipo } from "./paginas/Equipo.tsx";
import { Metricas } from "./paginas/Metricas.tsx";
import { Movimientos } from "./paginas/Movimientos.tsx";
import { Registrar } from "./paginas/Registrar.tsx";
import { Resumen } from "./paginas/Resumen.tsx";
import { Recibidos } from "./paginas/Recibidos.tsx";
import { CargasRechazadas } from "./paginas/CargasRechazadas.tsx";
import { Conexiones } from "./paginas/Conexiones.tsx";

export function App() {
  const { fase } = usarSesion();

  return (
    <Routes>
      {/* Pública: se llega por enlace, sin sesión y a propósito. */}
      <Route path="/invitacion" element={<AceptarInvitacion />} />
      {/* Fuera de la sesión a propósito: quien va a integrar tiene que poder
          leer el contrato ANTES de tener cuenta (SPEC-019 §2 bis). */}
      <Route path="/integracion" element={<Integracion />} />

      {fase === "comprobando" ? (
        <Route path="*" element={<Comprobando />} />
      ) : fase === "fuera" ? (
        <Route path="*" element={<Entrar />} />
      ) : (
        <Route element={<Marco />}>
          <Route index element={<Resumen />} />
          <Route path="/caja" element={<Caja />} />
          <Route path="/bandeja" element={<Bandeja />} />
          <Route path="/alertas" element={<Alertas />} />
          <Route path="/movimientos" element={<Movimientos />} />
          <Route path="/cartera" element={<Cartera />} />
          <Route path="/registrar" element={<Registrar />} />
          <Route path="/metricas" element={<Metricas />} />
          <Route path="/recibidos" element={<Recibidos />} />
          <Route path="/cargas-rechazadas" element={<CargasRechazadas />} />
          <Route path="/conexiones" element={<Conexiones />} />
          {/* La pantalla de revisión se fundió en Recibidos (SPEC-021 §6):
              "en revisión" es un filtro de "todo lo que llegó". La ruta vieja
              sobrevive porque un enlace guardado no puede morir por una
              decisión de menú nuestra. */}
          <Route path="/revision" element={<Navigate to="/recibidos" replace />} />
          <Route path="/equipo" element={<Equipo />} />
          <Route path="/configuracion" element={<Configuracion />} />
          <Route path="/empezar" element={<Empezar />} />
          <Route path="/cuenta" element={<Cuenta />} />
          <Route path="/entrar" element={<Navigate to="/" replace />} />
          <Route path="*" element={<NoExiste />} />
        </Route>
      )}
    </Routes>
  );
}

/**
 * El arranque pregunta al backend si hay sesión viva. Es una petición, no una
 * eternidad — pero sin esto la app parpadearía del login al panel cada vez que
 * alguien recarga.
 */
const Comprobando = () => (
  <div className="grid min-h-dvh place-items-center">
    <div className="flex flex-col items-center gap-4 text-sm text-tenue">
      <Marca className="size-11 pulso-suave" />
      <span>Comprobando tu sesión…</span>
    </div>
  </div>
);

const NoExiste = () => (
  <Tarjeta>
    <Vacio
      icono={Compass}
      titulo="Esa página no existe"
      accion={
        <Link to="/">
          <Boton variante="primario">Volver al resumen</Boton>
        </Link>
      }
    >
      Puede que el enlace esté viejo, o que esa sección todavía no exista.
    </Vacio>
  </Tarjeta>
);
